import { useMemo } from 'react';

import { getDefaultLegalContent } from '~/contentful/defaults/footer/footerDefaults';
import { contentfulRenderOptions } from '~/contentful/renderOptions';
import { extractReactComponentsFromField } from '~/contentful/utils';
import { useContentfulPageAssetBySlug } from '~/hooks/useContentful';

export const useFooterLegalContent = () => {
  const { data: legalCopyContent, error: legalCopyError } =
    useContentfulPageAssetBySlug('legal-copy');

  const renderOptions = useMemo(() => contentfulRenderOptions({}), []);
  const defaultLegalContent = getDefaultLegalContent();

  const legalContent = useMemo(() => {
    if (legalCopyError || !legalCopyContent?.Fields) {
      return defaultLegalContent;
    }

    try {
      const { body } = legalCopyContent.Fields;
      return extractReactComponentsFromField(body, renderOptions);
    } catch (error) {
      console.error('Error rendering legal content:', error);
      return defaultLegalContent;
    }
  }, [legalCopyContent, legalCopyError, renderOptions, defaultLegalContent]);

  return legalContent;
};
